/** UI-Texte des Renderers. Formularinhalte selbst kommen aus der Definition. */
const de = {
  next: "Weiter",
  clearValue: "Leeren",
  back: "Zurück",
  submit: "Absenden",
  submitting: "Wird gesendet …",
  ok: "OK",
  required: "Pflichtfeld",
  optional: "optional",
  orPress: "oder",
  enterToContinue: "zum Weitergehen",
  shiftEnterNewline: "Umschalt + Enter für eine neue Zeile",
  progress: (current: number, total: number) => `Schritt ${current} von ${total}`,
  pageAnnounce: (current: number, total: number, title?: string) => `Seite ${current} von ${total}${title ? `: ${title}` : ""}`,
  errorSummaryTitle: (n: number) => (n === 1 ? "Bitte prüfe diese Angabe:" : `Bitte prüfe diese ${n} Angaben:`),
  other: "Sonstiges",
  otherPlaceholder: "Bitte angeben",
  selectPlaceholder: "Bitte wählen …",
  yes: "Ja",
  no: "Nein",
  chooseMany: (min?: number, max?: number) =>
    min && max ? `Wähle ${min} bis ${max} Optionen.` : min ? `Wähle mindestens ${min}.` : max ? `Wähle bis zu ${max}.` : "Mehrfachauswahl möglich.",
  ratingLabel: (n: number, max: number) => `${n} von ${max}`,
  npsLow: "0 – sehr unwahrscheinlich",
  saveForLater: "Später weitermachen",
  saveForLaterHint: "Wir speichern deine bisherigen Angaben und geben dir einen persönlichen Link – damit geht es auch auf einem anderen Gerät weiter.",
  saveForLaterEmail: "E-Mail-Adresse (optional)",
  saveForLaterEmailHint: "Dann schicken wir dir den Link zu.",
  saveForLaterCreate: "Link erstellen",
  saveForLaterFailed: "Speichern hat nicht geklappt. Bitte versuch es noch einmal.",
  saveForLaterDone: (until: string) => `Gespeichert. Der Link ist bis ${until} gültig – bitte nicht weitergeben.`,
  saveForLaterEmailed: "Wir haben dir den Link per E-Mail geschickt.",
  copyLink: "Link kopieren",
  copied: "Kopiert",
  close: "Schließen",
  resumeRestored: (when: string) => `Dein Zwischenstand vom ${when} ist geladen.`,
  manageEdit: "Angaben ändern",
  managePdf: "Meine Angaben als PDF herunterladen",
  manageEditUntil: (until: string) => `Änderungen sind bis ${until} möglich.`,
  managePriceLocked: (fields: string) => `Bereits bezahlt: ${fields} lässt sich hier nicht mehr ändern – dafür bitte an das Team wenden.`,
  manageSaved: "Deine Änderungen sind gespeichert.",
  manageConflict: "Deine Angaben wurden inzwischen geändert. Bitte lade die Seite neu und versuch es noch einmal.",
  manageDecided: "Über deine Angaben wurde bereits entschieden. Änderungen bitte direkt beim Team anfragen.",
  manageFilesFixed: "Hochgeladene Dateien kannst du austauschen; Unterschriften lassen sich nachträglich nicht ändern.",
  groupAdd: (item: string) => `${item} hinzufügen`,
  groupRemove: (item: string, n: number) => `${item} ${n} entfernen`,
  groupAdded: (item: string, n: number) => `${item} ${n} hinzugefügt.`,
  groupRemoved: (item: string, n: number) => `${item} ${n} entfernt.`,
  transfersWaiting: "Dateien werden noch übertragen …",
  signatureClear: "Löschen",
  mailSaving: "Deine Antwort wird gespeichert …",
  mailSaved: "Danke – deine Antwort ist gespeichert.",
  mailFailed: "Das hat nicht geklappt. Bitte tippe deine Antwort noch einmal an.",
  mailChange: "Du kannst deine Antwort hier jederzeit ändern.",
  fromMailHere: "Deine Antwort aus der E-Mail ist schon markiert – du kannst sie noch ändern. Gespeichert wird sie erst mit dem Absenden.",
  fromMailBack: "Deine Antwort aus der E-Mail ist übernommen. Mit „Zurück“ kannst du sie ändern.",
  draftRestored: "Wir haben deine bisherigen Angaben wiederhergestellt.",
  draftRestoredAt: (when: string) => `Deine Angaben vom ${when} sind wiederhergestellt – gespeichert nur in diesem Browser auf diesem Gerät.`,
  draftChanged: "Das Formular wurde inzwischen geändert. Bitte prüfe deine Angaben; Fragen, die es nicht mehr gibt, wurden entfernt.",
  duration: (min: number) => (min <= 1 ? "Dauer: ca. 1 Minute" : `Dauer: ca. ${min} Minuten`),
  sections: "Abschnitte",
  sectionN: (n: number) => `Teil ${n}`,
  sectionDone: "erledigt",
  reviewTitle: "Bitte prüfe deine Angaben",
  reviewIntro: "Noch ist nichts abgeschickt. Du kannst jeden Abschnitt noch ändern.",
  reviewEdit: (section: string) => `${section} ändern`,
  reviewEmpty: "keine Angabe",
  draftDiscard: "Neu beginnen",
  redirecting: "Du wirst weitergeleitet …",
  redirectLink: "Weiter zur nächsten Seite",
  alreadySubmitted: "Du hast dieses Formular bereits ausgefüllt.",
  alreadySubmittedBody: "Danke! Wenn du etwas ändern möchtest, wende dich an die Veranstaltenden.",
  closedTitle: "Dieses Formular ist geschlossen.",
  notOpenYet: "Dieses Formular ist noch nicht geöffnet.",
  notFoundTitle: "Formular nicht gefunden",
  notFoundBody: "Prüfe den Link oder frag bei der Person nach, die ihn dir geschickt hat.",
  loadFailed: "Das Formular konnte nicht geladen werden. Prüfe deine Verbindung und lade die Seite neu.",
  submitFailed: "Senden fehlgeschlagen. Deine Angaben sind noch da – versuch es gleich noch einmal.",
  formClosedNow: "Dieses Formular nimmt inzwischen keine Antworten mehr an.",
  rateLimited: "Zu viele Versuche in kurzer Zeit. Warte einen Moment und versuch es dann noch einmal.",
  soldOut: "ausgebucht",
  updatedNotice: "Deine bisherige Antwort wurde aktualisiert.",
  waitlistBadge: "ausgebucht – Warteliste",
  waitlistNotice: "Du stehst auf der Warteliste. Sobald ein Platz frei wird, rückst du automatisch nach und bekommst Bescheid.",
  manageTitle: "Deine Anmeldung",
  manageStatus: { confirmed: "Bestätigt", waitlist: "Auf der Warteliste", cancelled: "Storniert" } as Record<string, string>,
  manageCancel: "Anmeldung stornieren",
  manageCancelConfirm: "Ja, endgültig stornieren",
  manageCancelHint: "Dein Platz wird frei und kann an jemanden von der Warteliste gehen. Das lässt sich nicht rückgängig machen.",
  manageCancelled: "Deine Anmeldung ist storniert. Danke, dass du Bescheid gegeben hast!",
  manageNotCancellable: "Für dieses Formular ist das Stornieren per Link nicht vorgesehen. Bitte melde dich bei den Veranstaltenden.",
  manageInvalid: "Dieser Link ist ungültig oder die Anmeldung wurde gelöscht.",
  remaining: (n: number) => (n === 1 ? "noch 1 Platz" : `noch ${n} Plätze`),
  poweredBy: "Erstellt mit Fobu",
  keyHint: (key: string) => `Taste ${key}`,
  videoOpen: "Video öffnen",
  resultsNoticeDetailed: "Nach dem Absenden siehst du die bisherigen Antworten. Dein Name und deine Antworten sind dort auch für andere Teilnehmende sichtbar.",
  resultsNoticeSummary: "Nach dem Absenden siehst du die bisherigen Ergebnisse – anonym zusammengefasst.",
  resultsShow: "Bisherige Antworten ansehen",
  resultsHide: "Antworten ausblenden",
  videoPlay: "Video abspielen",
  mediaEnlarge: "Groß anzeigen",
  dialogClose: "Schließen",
  documentOpen: "Öffnen",
  documentDownload: "Herunterladen",
  language: "Sprache",
  inviteOnlyTitle: "Nur mit persönlicher Einladung",
  inviteOnlyBody: "Dieses Formular ist nur über den Link aus deiner Einladungs-E-Mail erreichbar.",
  inviteUsedTitle: "Du hast bereits geantwortet – danke!",
  inviteUsedBody: "Mit diesem persönlichen Link wurde schon geantwortet. Wenn du etwas ändern möchtest, melde dich bei den Veranstaltenden.",
  passwordTitle: "Passwort nötig",
  passwordLabel: "Passwort",
  passwordHint: "Dieses Formular ist geschützt. Das Passwort hast du von den Veranstaltenden bekommen.",
  passwordWrong: "Das Passwort stimmt nicht.",
  passwordSubmit: "Öffnen",
};

export type Strings = typeof de;



/** Englisch wird nur geladen, wenn ein Formular es braucht (die meisten Formulare sind deutsch). */
let en: Strings | null = null;

/** Aktuelle UI-Texte. Live-Bindung: nach setLocale sehen alle Importe die neue Sprache. */
export let t: Strings = de;
export const isGerman = () => t === de;

/** Englisch für alles außer Deutsch. */
const needsEn = (lang: string) => lang.toLowerCase().split("-")[0] !== "de";

/** UI-Sprache setzen. Gibt `false` zurück, solange die Texte erst geladen werden müssen (dann `loadLocale`). */
export function setLocale(lang: string): boolean {
  if (!needsEn(lang)) return ((t = de), true);
  if (!en) return false;
  t = en;
  return true;
}

export async function loadLocale(lang: string): Promise<void> {
  if (needsEn(lang) && !en) en = (await import("./i18n-en")).en;
  setLocale(lang);
}

export const RTL = new Set(["ar", "fa", "he", "ur"]);
